export default __webpack_public_path__ + "static/media/healtea1.ff278e14.jpg";